import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Layout from './components/Layout/Layout';
import Dashboard from './pages/Dashboard';
import Agencies from './pages/Agencies';
import Articles from './pages/Articles';
import Domains from './pages/Domains';
import Earnings from './pages/Earnings';
import Analytics from './pages/Analytics';
import Billing from './pages/Billing';
import Settings from './pages/Settings';
import { migrateDataToFirebase, createSampleDataInFirebase } from './utils/firebase-migration';
import './App.css';

function App() {
  // Attempt to migrate data on app initialization
  useEffect(() => {
    const initializeFirebase = async () => {
      // First try to migrate existing localStorage data
      const migrationSuccessful = await migrateDataToFirebase();
      
      // If migration failed or there was no data to migrate, create sample data
      if (!migrationSuccessful) {
        await createSampleDataInFirebase();
      }
    };

    initializeFirebase();
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="agencies" element={<Agencies />} />
            <Route path="articles" element={<Articles />} />
            <Route path="domains" element={<Domains />} />
            <Route path="earnings" element={<Earnings />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="billing" element={<Billing />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 3000,
            style: {
              background: '#363636',
              color: '#fff',
            },
          }}
        />
      </div>
    </Router>
  );
}

export default App;